import BstlArtikel from "./bstl_artikel"
import Buchung from "./buchung"
import Identity from "./identity"
import Nachbestellung from "./nachbestellung"
import NachbestellungPending from "./nachbestellung_pending"
import Serviceanforderung from "./serviceanforderung"

export default class Bestellung extends Buchung {
  bezeichnung: string
  //filiale: BestellungFiliale = new BestellungFiliale()
  datum: string
  bestellZp: string
  lastModified: string
  stornierbarBis: string
  kommentare: string
  terminart: string
  abgeschlossen: boolean = false
  storniert: boolean = false
  aktuellerStatus: any = null
  statusaenderungen: any[] = []
  nachrichten: any[] = []
  sofort: Sofort = new Sofort()
  reservierung: Reservierung = new Reservierung()
  abholung: Abholung = new Abholung()
  lieferung: Lieferung = new Lieferung()
  neu: boolean = false
  artikelliste: BstlArtikel[] = []
  vorbestellung: BstlArtikel[] = []
  bezahlt: boolean = false
  orderId: string
  kuecheStatus: string
  duration: string
  bezahlart: string
  bestellNr: number
  trinkgeldType: string
  trinkgeld: number
  nachbestellungPending: NachbestellungPending
}

class Abholung {
  id?: string
  voraussAbholZp: string
  gewaehlterAbholZp: string
  type: string
  stornierbar: boolean = false
  aenderbar: boolean = false
  status: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
  abholnummer: string
  direktabholung: boolean
  tischId: string
  tischBezeichnung: string
  verzehrart: string

  angenommenZp: string
  angenommenBenutzerName: string
  angenommenBenutzerId: string
  inBearbeitungZp: string
  inBearbeitungBenutzerName: string
  inBearbeitungBenutzerId: string
  abgelehntZp: string
  abgelehntBenutzerName: string
  abgelehntBenutzerId: string
  abholbereitZp: string
  abholbereitBenutzerName: string
  abholbereitBenutzerId: string
  abgeholtZp: string
  abgeholtBenutzerName: string
  abgeholtBenutzerId: string
  nichtAbgeholtZp: string
  nichtAbgeholtBenutzerName: string
  nichtAbgeholtBenutzerId: string
}

class Reservierung {
  id: string
  tischId: string
  tischBezeichnung: string
  art: string
  zeitVon: string
  zeitBis: string
  personen: number = 0
  eingebucht: boolean = false
  eingebuchtZp: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
  vorbestellung: boolean
  bestellart: string
  status: string
  nachbestellungen: Nachbestellung[] = []
  serviceanforderungen: Serviceanforderung[] = []
  vorbestellungen: BstlArtikel[] = []
}

class Sofort {
  id: string
  tischId: string
  tischBezeichnung: string
  personen: number
  bestellart: string
  status: string
  betreuer: string
  nachbestellungen: Nachbestellung[] = []
  serviceanforderungen: Serviceanforderung[] = []
}

class Lieferung {
  id: string
  zeitType: string
  lieferzeitpunkt: string
  kundeNachname: string
  kundeVorname: string
  kundeStrasse: string
  kundePlz: string
  kundeOrt: string
  kundeTelefon: string
  kundeEmail: string
  kundeAdresszusatz: string
  kommentare: string
  lieferkosten: number = 0
  lieferungStatus: string
  voraussLieferzeit: string
  geliefertZeit: string
  lieferantName: string
  lieferantId: string
  liefergebietBezeichnung: string
  liefergebietId: string

  angenommenZp: string
  angenommenBenutzerName: string
  angenommenBenutzerId: string
  abgelehntZp: string
  abgelehntBenutzerName: string
  abgelehntBenutzerId: string
  inZubereitungZp: string
  inZubereitungBenutzerName: string
  inZubereitungBenutzerId: string
  zubereitetZp: string
  zubereitetBenutzerName: string
  zubereitetBenutzerId: string
  inLieferungZp: string
  inLieferungBenutzerName: string
  inLieferungBenutzerId: string
}
